import React, { useState, useEffect } from 'react'
import { Collapse } from '@mui/material'
import { Box, BoxProps } from '@fundamentals'
import { Button } from '@common/material/Button'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

type CollapsibleProps = BoxProps & {
  collapsed?: boolean
  label?: string | { collapsed: string; open: string }
  buttonProps?: {
    size?: 'small' | 'medium' | 'large'
    sx?: BoxProps['sx']
  }
  hidden?: boolean
  hideIcon?: boolean
}

const Collapsible: React.FC<CollapsibleProps> = ({
  collapsed,
  label,
  children,
  buttonProps,
  hidden,
  hideIcon,
  ...props
}) => {
  const [processedCollapsed, setCollapsed] = useState<boolean>(collapsed)
  useEffect(() => {
    setCollapsed(collapsed)
  }, [collapsed])

  const childrenArray = React.Children.toArray(children)

  if (React.Children.count(childrenArray) === 0 || hidden) {
    return null
  }

  return (
    <Box {...props}>
      <Collapse in={!processedCollapsed} timeout='auto' unmountOnExit>
        {childrenArray}
      </Collapse>
      <Button
        variant='text'
        size={buttonProps?.size || 'medium'}
        endIcon={
          !hideIcon &&
          (processedCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />)
        }
        onClick={() => setCollapsed(!processedCollapsed)}
        sx={buttonProps?.sx || { ml: '-8px', pb: 0, mt: 1 }}
      >
        {typeof label === 'string'
          ? label
          : label[processedCollapsed ? 'collapsed' : 'open']}
      </Button>
    </Box>
  )
}

export { Collapsible }
